import {
  GoogleMap,
  useLoadScript,
  Marker,
  Polygon,
  InfoWindow,
} from "@react-google-maps/api";
import { useEffect, useState, useContext } from "react";
import { ShapeContext } from "./Shapefile";
import { AuthContext } from "./Authentication";
import "./styles/Mapa.css";

const libraries = ["places"];

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

const mapContainerStyle = {
  flex: "1",
  //width: '100%',
  height: "500px",
};

function createPolygon() {
  return {
    points: [null],
    data: null,
    rgb: "",
  };
}

function createPoint(x, y) {
  return {
    lat: y,
    lng: x,
  };
}

function Mapa({ funcao, evento, campo, veiculo }) {
  const [coluna, setColuna] = useState(0);
  const { shpData, dbfData } = useContext(ShapeContext);
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyBvfH06FPkeWnrVt9LIn7HpRd-l-AN07Ks",
    libraries,
  });
  const [path, setPath] = useState(null);
  const [invalidMap, setInvalidMap] = useState(false);
  const { downloadFile } = useContext(AuthContext);

  useEffect(() => {
    if (veiculo != null) {
      console.log("veiculo não nulo");
      return;
    }
    const arrayPoligonos = [null];
    if (dbfData.numOfRecords === 0) {
      setInvalidMap(true);
      return;
    }
    setInvalidMap(false);
    for (let i = 0; i < shpData.record.length; i++) {
      const poligono = createPolygon();
      for (let j = 0; j < shpData.record[i].points.length; j++) {
        const point = createPoint(
          shpData.record[i].points[j].x,
          shpData.record[i].points[j].y
        );
        poligono.points[j] = point;
      }
      poligono.data = dbfData.records[coluna].data[i];
      if (poligono.data === 0) poligono.rgb = "#7f7f7f";
      else {
        const amplitude =
          dbfData.limites[coluna].limiteMax - dbfData.limites[coluna].limiteMin;
        const fator =
          ((poligono.data - dbfData.limites[coluna].limiteMin) * 2) / amplitude;
        if (fator < 1) {
          const arredondado = Math.floor(fator * 255);
          poligono.rgb = rgbToHex(255, arredondado, 0);
        } else {
          const arredondado = Math.floor(255 - (fator - 1) * 255);
          poligono.rgb = rgbToHex(arredondado, 255, 0);
        }
      }
      arrayPoligonos[i] = poligono;
    }
    setPath(arrayPoligonos);
  }, [coluna]);

  /*const center = {
    lat: campo.latReferencia, //-27.2905715, // default latitude
    lng: campo.lonReferencia, //-54.6337262, // default longitude
  };*/

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading maps</div>;
  }

  function handleDownloadShape(fileKey, filename) {
    console.log("Clicou para baixar");
    downloadFile(fileKey + ".dbf", filename + ".dbf")
      .then((data) => {
        downloadFile(fileKey + ".shp", filename + ".shp")
          .then((data) => {
            downloadFile(fileKey + ".shx", filename + ".shx").catch((err) =>
              console.log(err)
            );
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  }
  return (
    <div id="Map">
      <button onClick={() => funcao(1)}>Voltar</button>
      {!veiculo && evento && <h3>{evento.eventoNome}</h3>}
      {evento && campo && (
        <div className="evento-info-conteiner">
          <div className="evento-info">
            <p>Área aplicada Total:</p>
            <h3>{evento.areaAplicadaTotal} ha</h3>
          </div>
          <div className="evento-info">
            <p>Produto aplicado:</p>
            <h3>
              {evento.produtoAplicado === "0.0"
                ? "Não informado"
                : evento.produtoAplicado}
            </h3>
          </div>
          <div className="evento-info">
            <p>Taxa:</p>
            <h3>{evento.taxaFixa === true ? "Taxa Fixa" : "Taxa Variável"}</h3>
          </div>
          <div className="evento-info">
            <p>Tempo total:</p>
            <h3>{evento.tempoTotal}</h3>
          </div>
          <div className="evento-info">
            <p>Transpasse:</p>
            <h3>{evento.transpasse} ha</h3>
          </div>
          <div className="evento-info">
            <p>Velocidade média:</p>
            <h3>{evento.velMedia} km/h</h3>
          </div>
        </div>
      )}
      {veiculo && <h3>Veículo: {veiculo.nome}</h3>}
      <label>Coluna</label>
      {!veiculo && (
        <select value={coluna} onChange={(e) => setColuna(e.target.value)}>
          {dbfData.records.map((coluna) => (
            <option value={coluna.index}>{coluna.nomeColuna}</option>
          ))}
        </select>
      )}
      {!invalidMap && (
        <button
          onClick={() =>
            handleDownloadShape(
              evento.eventoUUID,
              `${campo.campoNome}-${evento.eventoNome}`
            )
          }
        >
          Download Shape
        </button>
      )}
      <div className="map-conteiner">
        {!invalidMap && (
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={veiculo ? 20 : 15}
            center={
              veiculo
                ? {
                    lat: parseFloat(veiculo.lat), //-27.2905715, // default latitude
                    lng: parseFloat(veiculo.lon),
                  }
                : {
                    lat:
                      shpData.boxYmin + (shpData.boxYmax - shpData.boxYmin) / 2, //-27.2905715, // default latitude
                    lng:
                      shpData.boxXmin + (shpData.boxXmax - shpData.boxXmin) / 2,
                  }
            }
            mapTypeId="satellite"
          >
            {veiculo && (
              <div>
                <Marker
                  position={{
                    lat: parseFloat(veiculo.lat), //-27.2905715, // default latitude
                    lng: parseFloat(veiculo.lon),
                  }}
                />
                <InfoWindow
                  onCloseClick={null}
                  position={{
                    lat: parseFloat(veiculo.lat), //-27.2905715, // default latitude
                    lng: parseFloat(veiculo.lon),
                  }}
                >
                  <div>
                    <h2>{veiculo.nome}</h2>
                    <p>Última lat: {veiculo.lat}</p>
                    <p>Última lon: {veiculo.lon}</p>
                    <p>Última alt: {veiculo.alt}</p>
                    <p>Última orientação: {veiculo.heading}</p>
                    <p>Última velocidade: {veiculo.vel * 3.6} km/h</p>
                  </div>
                </InfoWindow>
              </div>
            )}
            {campo && (
              <Marker
                position={{
                  lat: parseFloat(campo.latReferencia), //-27.2905715, // default latitude
                  lng: parseFloat(campo.lonReferencia),
                }}
              />
            )}
            {!veiculo &&
              path.map((poligono) => (
                <Polygon
                  path={poligono.points}
                  options={{
                    fillColor: poligono.rgb,
                    strokeWeight: 0.1,
                    fillOpacity: 1.0,
                  }}
                />
              ))}
          </GoogleMap>
        )}
      </div>
      {invalidMap && <p>Mapa não encontrado</p>}
      {veiculo && (
        <div className="evento-details">
          <p>Entreeixos: {veiculo.entreeixos} m</p>
          <p>Altura Antena: {veiculo.alturaAntena} m</p>
          <p>Offset Antena: {veiculo.offsetAntena} m</p>
          <p>Engate traseiro: {veiculo.hitchTraseiro} m</p>
        </div>
      )}
    </div>
  );
}

export default Mapa;
